class SCHomepage {
  constructor() {
    this.rsiHandleInput = document.getElementById('rsi-handle');
    this.submitButton = document.querySelector('.sc-submit-button');
    this.shopPayButton = document.querySelector('.shopify-payment-button__button');
    this.dynamicCheckoutButtons = document.querySelectorAll('.shopify-payment-button__button, .shopify-payment-button__more-options');
    this.productForm = document.querySelector('form[action="/cart/add"]');
      
    this.init();
    this.createNotificationElement();
    this.createWarningElement();
  }
  
  createNotificationElement() {
    const notification = document.createElement('div');
    notification.className = 'sc-cart-notification';
    notification.style.top = '200px';
    notification.innerHTML = `
        <div class="sc-cart-notification__content">
              <div class="sc-cart-notification__header">
                  <div class="sc-cart-notification__icon-wrapper">
                      <svg class="sc-cart-notification__icon" width="20" height="20" viewBox="0 0 24 24">
                          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                      </svg>
                  </div>
                  <span class="sc-cart-notification__title"></span>
              </div>
              <div class="sc-cart-notification__body">
                  <span class="sc-cart-notification__message">Successfully added to your cart</span>
                  <a href="/cart" class="sc-cart-notification__checkout">
                      Proceed to Check out
                      <svg width="16" height="16" viewBox="0 0 24 24">
                          <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z"/>
                      </svg>
                  </a>
              </div>
          </div>
      `;
    document.body.appendChild(notification);
    this.cartNotification = notification;
  }

  createWarningElement() {
    const warningSpan = document.createElement('span');
    warningSpan.className = 'rsi-warning';
    warningSpan.style.color = 'red';
    warningSpan.style.display = 'none';
    warningSpan.textContent = 'Please enter your RSI Handle ';
    this.rsiHandleInput.parentNode.appendChild(warningSpan);
    this.warningElement = warningSpan;
  }

  showWarningMessage() {
    this.warningElement.style.display = 'block';
    setTimeout(() => {
        this.warningElement.style.display = 'none';
    }, 3000);
  }

  init() {
    this.setupEventListeners();
  }
  
  setupEventListeners() {
    if (this.productForm) {
      this.productForm.addEventListener('submit', (e) => {
        e.preventDefault();
        if (this.isRSIHandleValid()) {
          this.handleAddToCart();
        } else {
          this.showWarningMessage();
          this.rsiHandleInput.focus();
        }
      });
    }

    this.dynamicCheckoutButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        if (!this.isRSIHandleValid()) {
          e.preventDefault();
          e.stopPropagation();
          this.showWarningMessage();
          this.rsiHandleInput.focus();
          return false;
        }
        
        const existingProperty = this.productForm.querySelector('input[name="properties[RSI Handle]"]');
        if (!existingProperty) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[RSI Handle]';
          input.value = this.rsiHandleInput.value.trim();
          this.productForm.appendChild(input);
        } else {
          existingProperty.value = this.rsiHandleInput.value.trim();
        }
      }, true);
    });
  }

  handleAddToCart() {
    const formData = new FormData(this.productForm);
    formData.append('properties[RSI Handle]', this.rsiHandleInput.value.trim());
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    })
    .then((response) => response.json())
    .then((data) => {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const headerCartCount = document.getElementById('cart-icon-bubble');
          if (headerCartCount) {
            const cartBubble = headerCartCount.querySelector('.cart-count-bubble') || document.createElement('div');
            cartBubble.className = 'cart-count-bubble';
            cartBubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} items</span>`;
            
            if (!headerCartCount.querySelector('.cart-count-bubble')) {
              headerCartCount.appendChild(cartBubble);
            }
          }
        });

      const notificationTitle = this.cartNotification.querySelector('.sc-cart-notification__title');
      notificationTitle.textContent = data.product_title;
      
      this.cartNotification.classList.add('active');
      setTimeout(() => {
        this.cartNotification.classList.remove('active');
      }, 8000);
    })
    .catch((error) => {
      console.error('Error adding to cart:', error);
    });
  }

  isRSIHandleValid() {
    return this.rsiHandleInput.value.trim().length > 0;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SCHomepage();
});
